(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["fg-product-also-like"] && !Shopify.designMode) return;
  try {
    
  class WIYouMayAlsoLike extends FGUpsellCarousel {
    #strikethroughPrice = '';

    constructor() {
      super();
      this.#strikethroughPrice = this.dataset.strikethroughPrice;
    }

    async connectedCallback() {
      await super.connectedCallback();
      try {
        yotpoWidgetsContainer.initWidgets();
      } catch (e) {
        console.error('Could not init yotpo widgets', e);
      }
    }

    getIntialDisplayCount() {
      return 5;
    }

    getTemplateConfig() {
      return {
        ...super.getTemplateConfig(),
        atcTemplateId: 'fg-ymal-atc-tpl',
        itemInfoTemplateId: 'fg-ymal-upsell-item-info-tpl',
      };
    }

    getFlickityConfig() {
      return {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        watchCSS: true,
      };
    }

    setPopulatedItem(carouselSlide, recommendation) {
      super.setPopulatedItem(carouselSlide, recommendation);
      const starRatings = carouselSlide.querySelector('.yotpo-widget-instance');
      starRatings.setAttribute('data-yotpo-product-id', recommendation.id);
      starRatings.setAttribute('data-yotpo-cart-product-id', recommendation.id);
      if (this.isStrikethroughEligible(recommendation)) {
        carouselSlide.querySelector('[data-item-price]').textContent = `$${this.#strikethroughPrice}`;
      }

      const itemContainer = carouselSlide.querySelector('[data-item-container]');
      const anchorWrap = document.createElement('a');
      anchorWrap.setAttribute('href', recommendation.url);
      anchorWrap.setAttribute('title', recommendation.title);
      carouselSlide.insertBefore(anchorWrap, itemContainer);
      anchorWrap.appendChild(itemContainer);
    }

    onEmptyRecommendations() {
      const thisSection = this.closest('.section-fg-pdp-you-may-also-like');
      thisSection.style.display = 'none';
    }

    isStrikethroughEligible(product) {
      if (!this.#strikethroughPrice) {
        return false;
      }
      if (product.type === 'Bottle' && !product.tags.includes('no-strikethrough')) {
        return true;
      }
      return false;
    }

    async onAddToCart(event) {
      const sectionConfigs = [
        { section: 'cart-drawer', childSelector: '#Cart-Drawer', replacesSelector: '#Cart-Drawer' },
        {
          section: 'cart-bubble',
          childSelector: '#cart-drawer-toggle .thb-item-count',
          replacesSelector: '#cart-drawer-toggle .thb-item-count',
        },
      ];
      await super.onAddToCart(event, sectionConfigs);

      const cartDrawer = document.getElementById('Cart-Drawer');
      cartDrawer?.notesToggle();
      cartDrawer?.removeProductEvent();
      cartDrawer?.classList.add('active');
      document.body.classList.add('open-cart');
      document.body.classList.add('open-cc');
      document.dispatchEvent(new Event('cart:item-added'));
    }
  }
  customElements.define('wi-also-like', WIYouMayAlsoLike);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["fg-product-bought-together"] && !Shopify.designMode) return;
  try {
    
  class WIBoughtTogether extends FGUpsellCarousel {
    #strikethroughPrice = '';
    #selectedProducts = [];

    constructor() {
      super();
      this.#strikethroughPrice = this.dataset.strikethroughPrice;
    }

    async connectedCallback() {
      await super.connectedCallback();
    }

    updateContent() {
      super.updateContent();
      const thisItemCheckbox = document.querySelector(
        '.fg-pdp-bought-together-wrapper .current-product .checkbox-container input'
      );
      this.#selectedProducts.push({
        variantId: thisItemCheckbox.dataset.variantId,
        price: thisItemCheckbox.dataset.price,
        comparePrice: thisItemCheckbox.dataset.comparePrice,
      });
      thisItemCheckbox.addEventListener('change', (event) => {
        this.#onCheckboxChange(event);
      });
      const addToCartButton = document.querySelector(
        '.fg-pdp-bought-together-wrapper .footer-container [data-atc-button]'
      );
      addToCartButton.addEventListener('click', (event) => {
        const selectedVariantIds = this.#selectedProducts.map((product) => product.variantId);
        event.currentTarget.setAttribute('data-variant-id', JSON.stringify(selectedVariantIds));
        this.onAddToCart(event);
      });
      this.#computePrice();
    }

    setPopulatedItem(carouselSlide, recommendation) {
      super.setPopulatedItem(carouselSlide, recommendation);

      const itemContainer = carouselSlide.querySelector('[data-item-container]');
      const anchorWrap = document.createElement('a');
      anchorWrap.setAttribute('href', recommendation.url);
      anchorWrap.setAttribute('title', recommendation.title);
      carouselSlide.insertBefore(anchorWrap, itemContainer);
      anchorWrap.appendChild(itemContainer);

      const checkbox = carouselSlide.querySelector('.checkbox-container input');
      checkbox.setAttribute('data-variant-id', recommendation.variants[0].id);
      const newSelected = {
        variantId: recommendation.variants[0].id,
        comparePrice: recommendation.compare_at_price,
        price: recommendation.price,
      };
      if (this.isStrikethroughEligible(recommendation)) {
        const strikethroughCents = this.#strikethroughPrice.replace('.', '');
        checkbox.setAttribute('data-price', strikethroughCents);
        newSelected.price = strikethroughCents;
        carouselSlide.querySelector('[data-item-price]').textContent = `$${this.#strikethroughPrice}`;
      } else {
        checkbox.setAttribute('data-price', recommendation.price);
      }
      checkbox.setAttribute('data-compare-price', recommendation.compare_at_price);
      this.#selectedProducts.push(newSelected);
      checkbox.checked = true;
      checkbox.addEventListener('change', (event) => {
        this.#onCheckboxChange(event);
      });
    }

    isStrikethroughEligible(product) {
      if (!this.#strikethroughPrice) {
        return false;
      }
      if (product.type === 'Bottle' && !product.tags.includes('no-strikethrough')) {
        return true;
      }
      return false;
    }

    #onCheckboxChange(event) {
      const element = event.currentTarget;
      const container = element.closest('[data-carousel-item]') || element.closest('.current-product');
      if (!element.checked) {
        container.classList.add('faded');
        this.#selectedProducts = this.#selectedProducts.filter(
          (product) => product.variantId != element.dataset.variantId
        );
      } else {
        container.classList.remove('faded');
        this.#selectedProducts.push({
          variantId: element.dataset.variantId,
          price: element.dataset.price,
          comparePrice: element.dataset.comparePrice,
        });
      }
      const addToCartButton = document.querySelector(
        '.fg-pdp-bought-together-wrapper .footer-container [data-atc-button]'
      );
      if (this.#selectedProducts.length === 0) {
        addToCartButton.disabled = true;
      } else {
        addToCartButton.disabled = false;
      }
      this.#computePrice();
    }

    #computePrice() {
      const price = this.#selectedProducts
        .map((product) => parseInt(product.price, 10))
        .reduce((acc, cur) => acc + cur, 0);

      const comparePrice = this.#selectedProducts
        .map((product) => parseInt(product.comparePrice, 10))
        .reduce((acc, cur) => acc + cur, 0);

      const priceContainer = document.querySelector(
        '.fg-pdp-bought-together-wrapper .footer-container .price-container'
      );
      priceContainer.querySelector('.price').textContent = `$${this.dollars(price)}`;
      priceContainer.querySelector('.compare-price').textContent = `$${this.dollars(comparePrice)}`;
    }

    getIntialDisplayCount() {
      return 2;
    }

    getTemplateConfig() {
      return {
        ...super.getTemplateConfig(),
        itemTemplateId: 'fg-bought-together-upsell-item-tpl',
        atcTemplateId: 'fg-bought-together-upsell-atc-tpl',
      };
    }

    getFlickityConfig() {
      return {
        cellAlign: 'left',
        contain: true,
        pageDots: false,
        watchCSS: true,
      };
    }

    onEmptyRecommendations() {
      const thisSection = this.closest('.section-fg-pdp-bought-together');
      thisSection.style.display = 'none';
    }

    async onAddToCart(event) {
      const sectionConfigs = [
        { section: 'cart-drawer', childSelector: '#Cart-Drawer', replacesSelector: '#Cart-Drawer' },
        {
          section: 'cart-bubble',
          childSelector: '#cart-drawer-toggle .thb-item-count',
          replacesSelector: '#cart-drawer-toggle .thb-item-count',
        },
      ];
      await super.onAddToCart(event, sectionConfigs);

      const cartDrawer = document.getElementById('Cart-Drawer');
      cartDrawer?.notesToggle();
      cartDrawer?.removeProductEvent();
      cartDrawer?.classList.add('active');
      document.body.classList.add('open-cart');
      document.body.classList.add('open-cc');
      document.dispatchEvent(new Event('cart:item-added'));
    }
  }
  customElements.define('wi-bought-together', WIBoughtTogether);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
  const hideYotpo = () => {
    const productContainer = document.querySelector('.thb-product-detail');
    // hide yotpo if we're looking at a pack page
    if(productContainer.dataset.productType === 'pack') {
      const yotpoContainer = document.querySelector('div[id*="yotpo_product_reviews_reviews"]');
      yotpoContainer.remove();
    }
  }

  (() => {
    hideYotpo();
  })()

  } catch(e) { console.error(e); }
})();
})();
